import React from "react";
import moment from "moment";

const PaymentDetails = ({ invoice, currency }) => {
  const { cost, total, unused } = invoice;
  const today = moment();
  return (
    <article className="plan-card">
      <div className="row div-small-text plan-cost-padding">
        <span>Plan Cost</span>
        <span>
          {currency}
          {Number(cost).toLocaleString()}
        </span>
      </div>
      <div className="row div-small-text unused-time-padding">
        <span>Unused time on plan after {today.format("MMM D, YYYY")}</span>
        <span>
          {currency}
          {Number(unused * -1).toLocaleString()}
        </span>
      </div>
      <div className="row subtotal-row">
        <span className="font-bold">Subtotal</span>
        <span className="font-bold">
          {currency}
          {Number(total).toLocaleString()}
        </span>
      </div>
    </article>
  );
};

export default PaymentDetails;
